import { ImageCarouselController } from './image-carousel.controller.js'

function imageCarousel () {
  return {
    restrict: 'E',
    scope: {
      materials: '<',
      selectedIndex: '='
    },
    templateUrl: '/arts/directives/image-carousel/image-carousel.html?$$REVISION$$',
    controller: ImageCarouselController
  }
}

export { imageCarousel }
